import React, { useEffect, useRef, useState } from 'react';
import BrandLiveCard, { BrandLiveCardAd, BrandLiveCardShape } from './brand-live-card';

// Khung xem trước: nền livestream mẫu 16:9, thẻ đặt đúng vị trí như trên overlay thật (cùng toạ độ
// 1920x1080 rồi thu nhỏ theo bề rộng khung).

const POSITION: Record<BrandLiveCardShape, React.CSSProperties> = {
  Corner: { position: 'absolute', right: 24, bottom: 24 },
  BottomBar: { position: 'absolute', left: 0, right: 0, bottom: 0 },
  Vertical: { position: 'absolute', right: 24, top: 24 },
};

const BrandLivePreviewFrame: React.FC<{ ad: BrandLiveCardAd; shape: BrandLiveCardShape }> = ({ ad, shape }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(0.25);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const update = () => setScale(el.clientWidth / 1920 || 0.25);
    update();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className="relative w-full overflow-hidden rounded-lg bg-slate-900"
      style={{ aspectRatio: '16 / 9' }}
    >
      <div className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-white/30">
        Livestream mẫu
      </div>
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: 1920,
          height: 1080,
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
        }}
      >
        <div style={POSITION[shape]}>
          <BrandLiveCard ad={ad} shape={shape} preview />
        </div>
      </div>
    </div>
  );
};

export default BrandLivePreviewFrame;
